import React from "react";
import StandardModal from "./shared/StandardModal";
import { MoveFocusInside } from "react-focus-lock";
import PropTypes from "prop-types";
import ToggleSwitch from "js/components/shared/ToggleSwitch";
import { InfoBox } from "./shared/InfoBox";
import { PrimaryButton } from "./shared/button/PrimaryButton";
import { convertYoutubeUrlToNoCookieYoutubeUrl, isYoutubeVideoUrl } from "js/utils/urlUtils";
import * as clsApi from "../api/classroomApi";
import { useSelectedClassroomStore } from "stores/v2/selectedClassroomStore";
export default class SendNewTabModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			currentUrl: "",
			sending: false,
			error: false,
			yotubeFullscreen: false,
		};
	}

	sendMessage = () => {
		if (!this.state.currentUrl) {
			this.setState({ error: "Please enter a website" });
			return;
		}

		let finalUrl = this.state.currentUrl;

		if (this.state.yotubeFullscreen) {
			finalUrl = convertYoutubeUrlToNoCookieYoutubeUrl(this.state.currentUrl);
		}
		this.setState({ sending: true, error: false });
		const payload = {
			classroom_source_id: this.props.classroomSourceId,
			event_object: {
				url: finalUrl,
			},
		};
		if (this.props.users) {
			payload.recipients = this.props.users.map((user) => user.username);
		}

		payload.classroom_id = useSelectedClassroomStore.getState().id;
		clsApi.Post(
			"events/open-tab",
			payload,
			(result) => {
				this.close();
			},
			(result) => {
				this.setState({
					sending: false,
					error: "There was a problem opening tabs",
				});
			}
		);
	};

	renderButtons = () => {
		return (
			<React.Fragment>
				{!this.state.sending ? (
					<PrimaryButton data-cy="sendNewTabModal_openButton" className="mui-flat-button" label="Open Site" onClick={this.sendMessage} />
				) : (
					<PrimaryButton className="mui-flat-button" label="Sending..." />
				)}
			</React.Fragment>
		);
	};

	close = () => {
		this.setState({ sending: false, currentUrl: "" });
		this.props.onClose();
	};

	handleChange = (event) => {
		this.setState({ currentUrl: event.target.value });
	};

	handleInputEnter = (ev) => {
		if (ev.key === "Enter") {
			ev.stopPropagation();
			this.sendMessage();
		}
	};

	isYoutubeVideoUrlChecks = (url) => {
		if (!this.props.open) return false;
		return isYoutubeVideoUrl(url);
	};

	handleToggleSwitch = () => {
		this.setState({ yotubeFullscreen: !this.state.yotubeFullscreen });
	};

	render() {
		return (
			<StandardModal size="medium" title={this.props.title} open={this.props.open} close={this.close} actions={this.renderButtons()}>
				<form data-cy="sendNewTabModal_form" onSubmit={(ev) => ev.preventDefault()}>
					<label className="block-label">Website URL</label>
					<MoveFocusInside>
						<input
							className="form-input"
							onChange={this.handleChange}
							onKeyDown={this.handleInputEnter}
							value={this.state.currentUrl}
							placeholder="www.google.com"
							spellCheck="false"
							type="text"
						/>
					</MoveFocusInside>
					<br />
					{this.isYoutubeVideoUrlChecks(this.state.currentUrl) && (
						<React.Fragment>
							<div style={{ display: "flex" }}>
								<ToggleSwitch checked={this.state.yotubeFullscreen} onToggle={this.handleToggleSwitch} />
								&nbsp; Open in Full Screen Mode
							</div>
							<InfoBox type="info" canClose={true}>
								Locks YouTube in full screen mode, removing comments and other distractions.
							</InfoBox>
						</React.Fragment>
					)}
					{this.state.error && <div className={"error"}>{this.state.error}</div>}
				</form>
			</StandardModal>
		);
	}
}

SendNewTabModal.propTypes = {
	users: PropTypes.arrayOf(PropTypes.object),
	open: PropTypes.bool,
	title: PropTypes.string,
	onClose: PropTypes.func,
};
